let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6F0xO")).then(() => parcelRequire('dF4iL'));